var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkRedirect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.89805 2.85409L1.44803 10.3251C1.28014 10.493 1.08064 10.5769 0.849512 10.5769C0.618946 10.5769 0.419719 10.493 0.251831 10.3251C0.0839436 10.1572 0 9.9577 0 9.72657C0 9.49601 0.0839436 9.29678 0.251831 9.12889L7.72283 1.67888H1.3431C1.10526 1.67888 0.905754 1.59857 0.744582 1.43796C0.583969 1.27679 0.503663 1.07728 0.503663 0.839438C0.503663 0.601597 0.583969 0.402091 0.744582 0.240919C0.905754 0.0803064 1.10526 0 1.3431 0H9.73748C9.97533 0 10.1746 0.0803064 10.3352 0.240919C10.4963 0.402091 10.5769 0.601597 10.5769 0.839438V9.23382C10.5769 9.47166 10.4963 9.67089 10.3352 9.8315C10.1746 9.99267 9.97533 10.0733 9.73748 10.0733C9.49964 10.0733 9.30042 9.99267 9.1398 9.8315C8.97863 9.67089 8.89805 9.47166 8.89805 9.23382V2.85409Z",
    fill: "#19FB80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkRedirect);
export default __webpack_public_path__ + "static/media/link-redirect.fb98fe6cc2d89c9f7f835e436bbb2ecb.svg";
export { ForwardRef as ReactComponent };